



























import Vue from "vue";
import jwt_decode from "jwt-decode";
import { mapState } from "vuex";
import { RootState } from "@/store";
import { LocalStorageManager, LocalStorageRequests } from "@/plugins/LocalStorageManager";

export default Vue.extend({
    data: () => ({
        idToken: null,
        azureUserId: null,
        azureUserDisplayName: null,
        azureUserGroupsIDs: [],
    }),
    props: ["debugMode", "autoLoginEnabled", "params"],
    computed: {
        ...mapState({
            startupData: (state: RootState) => state.application.startupData,
        }),
        isDebug: () => process.env.NODE_ENV == "development",
    },
    methods: {
        goToAzureHtmlPage(logout: boolean) {
            var azureHtmlPageUrl = this.isDebug ? "http://localhost/clink/azure_debug.html" : window.location.protocol + "//" + window.location.host + "/clink/azure.html";
            azureHtmlPageUrl = azureHtmlPageUrl + "?loginOnMount=" + (this.isDebug ? false : logout ? false : true);
            azureHtmlPageUrl = azureHtmlPageUrl + "&callback=" + this.$route.path.replace("/", "@");
            if (this.params) {
                azureHtmlPageUrl = azureHtmlPageUrl + "&clinkRedirectPage=" + this.params.clinkRedirectPage.replaceAll("/", "@").replaceAll("#", "$");
                azureHtmlPageUrl = azureHtmlPageUrl + "&msalConfig_auth_clientId=" + this.params.msalConfig_auth_clientId.replaceAll("/", "@").replaceAll("#", "$");
                azureHtmlPageUrl = azureHtmlPageUrl + "&msalConfig_auth_authority=" + this.params.msalConfig_auth_authority.replaceAll("/", "@").replaceAll("#", "$");
            }
            if (logout) azureHtmlPageUrl = azureHtmlPageUrl + "&isLogout=true";
            console.log("azureHtmlPageUrl: ", azureHtmlPageUrl);
            window.location.href = azureHtmlPageUrl;
        },

        logoutFromAzure() {
            LocalStorageManager.Remove(LocalStorageRequests.AzureAccessToken);
            this.goToAzureHtmlPage(true);
        },

        parseJWT() {
            // parso il token JWT e recupero id utente, nome utente e gruppi azure a cui appartiene
            var decodedToken = jwt_decode(this.idToken);
            this.azureUserId = decodedToken["oid"];
            this.azureUserDisplayName = decodedToken["name"];
            this.azureUserGroupsIDs = decodedToken["groups"];
        },

        emitLogin() {
            //emetto l'evento con tutte le info dell'utente azure
            this.$emit("azure-user-info-and-group-new-value", {
                azureUserId: this.azureUserId,
                azureUserDisplayName: this.azureUserDisplayName,
                azureUserGroupsIDs: this.azureUserGroupsIDs,
            });
        },
    },
    created() {
        this.idToken = null;

        if (this.$route != null && this.$route.query != null && this.$route.query.idToken != null) {
            console.log("Found Azure idToken in the URL");
            this.idToken = this.$route.query.idToken;
            LocalStorageManager.Write(LocalStorageRequests.AzureAccessToken, this.idToken);
            this.parseJWT();
            this.emitLogin();
        } else if (LocalStorageManager.Read(LocalStorageRequests.AzureAccessToken) != null) {
            console.log("Found Azure idToken in the browser local storage");
            this.idToken = LocalStorageManager.Read(LocalStorageRequests.AzureAccessToken);
            this.parseJWT();
            if (this.autoLoginEnabled) this.emitLogin();
        } else console.warn("No Azure AD token found.");
    },
});
